import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"
import { body50, headline50 } from "css/text"

import Picture from "components/media/ImageCLD"
import Link from "components/link/Link"

const Root = styled.section`
  ${fullGrid}
  align-items: center;
  padding-block: 10vh;
  background: rgb(var(--pure-white));
`

const Figure = styled.figure`
  align-self: center;
  grid-column: main;
  margin-block-end: 2.5rem;

  ${getMediaQuery("m")} {
    grid-column: col 2 / span 4;
    margin-block-end: unset;
  }

  ${getMediaQuery("l")} {
    grid-column: col 3 / span 4;
  }

  img {
    display: block;
    width: 100%;
  }
`

const Textblock = styled.div`
  grid-column: main;

  ${getMediaQuery("m")} {
    grid-column: col 7 / span 6;
  }

  ${getMediaQuery("l")} {
    grid-column: col 8 / span 4;
  }
`

const Title = styled.h2`
  ${headline50}
  margin-block-end: 1.25rem;
`

const Text = styled.p`
  ${body50}
`

const StyledLink = styled.div`
  margin-block-start: 1.875rem;
`

export default function ModelRetailer(props) {
  const {
    push_title: title,
    push_text: text,
    push_cta: label,
    push_image_landscape_cl: push_image_landscape,
    push_image_portrait_cl: push_image_portrait,
  } = props
  const console = useConsole()

  const [portrait, landscape] = [push_image_portrait, push_image_landscape].map(image => JSON.parse(image)[0])

  const picture = {
    sources: [
      {
        public_id: portrait.src,
        width: "1200",
        height: "1200",
        policy: portrait.policy,
        metadata: { v7_type: ["portrait"] },
      },
      {
        public_id: landscape.src,
        width: "1200",
        height: "1200",
        policy: landscape.policy,
      },
    ],
  }

  console.verbose("Model:ModelRetailer(%o)", props)
  return (
    <Root>
      <Figure>
        <Picture {...picture} loading='lazy' sizes='(min-width: 48rem) 42vw, 85vw' />
      </Figure>
      <Textblock>
        <Title>{title}</Title>
        <Text>{text}</Text>
        {label && (
          <StyledLink>
            <Link className='inline green' href='/store-locator' icon='chevron'>
              {label}
            </Link>
          </StyledLink>
        )}
      </Textblock>
    </Root>
  )
}
